import { Link } from "react-router-dom";
import {
  NavigationMenu,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";
import { UserStatus } from "./UserStatus";
import { NavigationLinks } from "./NavigationLinks";
import { SearchBar } from "./SearchBar";
import { LogoutButton } from "./LogoutButton";
import { Settings, Heart, LayoutDashboard } from "lucide-react";
import { navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";

interface DesktopNavigationProps {
  userRole: "talent" | "recruiter" | null;
  isOpenToJobs: boolean;
  isHiring: boolean;
  setIsOpenToJobs: (value: boolean) => void;
  setIsHiring: (value: boolean) => void;
  subscription: any;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  handleSearch: (e: React.FormEvent) => void;
  unreadCount: number;
}

export const DesktopNavigation = ({
  userRole,
  isOpenToJobs,
  isHiring,
  setIsOpenToJobs,
  setIsHiring,
  subscription,
  searchQuery,
  setSearchQuery,
  handleSearch,
  unreadCount,
}: DesktopNavigationProps) => {
  const { t } = useTranslation();

  return (
    <div className="border-b hidden md:block fixed top-0 left-0 right-0 bg-background/80 backdrop-blur-md z-50">
      <div className="max-w-[2000px] mx-auto flex items-center justify-between h-16 px-4 lg:px-6">
        <div className="flex items-center gap-4 lg:gap-6">
          <Link to="/" className="flex-shrink-0 hover:opacity-80 transition-opacity">
            <img 
              src="/app_images/Sonho_Favicon_V2.png" 
              alt="Sonho" 
              className="h-8 w-8"
            />
          </Link>
          <UserStatus 
            userRole={userRole}
            isOpenToJobs={isOpenToJobs}
            isHiring={isHiring}
            setIsOpenToJobs={setIsOpenToJobs}
            setIsHiring={setIsHiring}
          />
        </div>

        <NavigationMenu className="hidden lg:flex flex-1 justify-center mx-6">
          <NavigationMenuList className="gap-6">
            <NavigationLinks subscription={subscription} />
          </NavigationMenuList>
        </NavigationMenu>

        <div className="flex items-center gap-2 lg:gap-4">
          <SearchBar 
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            handleSearch={handleSearch}
          />
          <div className="flex items-center gap-2 lg:gap-4">
            <Link 
              to="/profile" 
              className={`${navigationMenuTriggerStyle()} border border-input bg-transparent hover:bg-accent hover:text-accent-foreground transition-colors`}
            >
              <LayoutDashboard className="h-4 w-4 sm:mr-2" />
              <span>{t('nav.portfolio')}</span>
            </Link>
            <Link 
              to="/mailbox" 
              className={`${navigationMenuTriggerStyle()} border border-input bg-transparent hover:bg-accent hover:text-accent-foreground transition-colors relative`}
            >
              <Heart className="h-4 w-4 sm:mr-2" />
              <span>{t('nav.mailbox')}</span>
              {unreadCount > 0 && (
                <Badge 
                  className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 bg-primary text-white"
                  variant="default"
                >
                  {unreadCount}
                </Badge>
              )}
            </Link>
            <Link 
              to="/settings" 
              className={`${navigationMenuTriggerStyle()} border border-input bg-transparent hover:bg-accent hover:text-accent-foreground transition-colors`}
            >
              <Settings className="h-4 w-4 sm:mr-2" />
              <span>{t('nav.settings')}</span>
            </Link>
            <LogoutButton />
          </div>
        </div>
      </div>
    </div>
  );
};